module.exports = require('./helpers/bundle-url').getBundleURL('5Beya') + "logo-dark.eefe0b7f.svg";